import React, { FunctionComponent } from 'react';
import classnames from 'classnames';

type Props = {
  isConnectModalOpen: boolean;
  isConnectCompleteModalOpen: boolean;
  isLoggedIn: boolean;
  isPerson: boolean;
  isScouted: boolean;
  showMidCareerWarning: boolean;
  companyId: number;
  recruitmentId?: number;
  interest: 'want_to_work' | 'want_to_hear' | 'interesting';
  isSubmitting: boolean;
  handleSubmitConnect: (e: React.MouseEvent<HTMLButtonElement>) => void;
  handleChangeInterest: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const Presentation: FunctionComponent<Props> = ({
  isConnectModalOpen,
  isConnectCompleteModalOpen,
  isLoggedIn,
  isPerson,
  isScouted,
  showMidCareerWarning,
  companyId,
  recruitmentId,
  interest,
  isSubmitting,
  handleSubmitConnect,
  handleChangeInterest,
}) => {
  return (
    <>
      {/* PC 用 */}
      <aside className="modal-connect modal-connect-first modal-connect--recruitment pc" style={{ display: isConnectModalOpen ? 'block' : 'none' }} onClick={(e) => e.stopPropagation()}>
        {isPerson && isScouted && (
          <h2 className="modal-connect-heading-updated first">
            スカウトを受けた求人です
          </h2>
        )}

        <h2 className="modal-connect-heading">
          エントリーするとできること
          <p className="modal-connect-heading-warning">
            {showMidCareerWarning && '※転職・中途向けの求人ですが、本当にエントリーしますか？'}
          </p>
        </h2>

        <div className="modal-connect-inner">
          <form className="modal-connect-form">
            <p className='text'>
            企業とメッセージでやり取りできます。気になることや伝えたいことがあれば、メッセージで企業に伝えてみましょう。
            </p>

            <div className="modal-connect-button dataLayer_company_id" id={`${companyId}`}>
              {!isLoggedIn ? (
                <>
                  <button className="button button-block">
                    まずはエントリーする
                  </button>
                  <p className="modal-connect-text modal-connect-text-first">
                    (ログインが必要です)
                  </p>
                </>
              ) : (
                <button
                  type="button"
                  className="button button-block button-submit gtm-entry-view-count"
                  onClick={handleSubmitConnect}
                  data-event-name='entry on screen'
                  data-event="click"
                  data-category="recruitmentcontent"
                  data-value="popup_entry"
                  disabled={isSubmitting}
                >
                  まずはエントリーする
                </button>
              )}

              <input id="recruitment_id" type="hidden" value={recruitmentId} />
            </div>
          </form>
        </div>
      </aside>

      {/* SP 用 */}
      <aside
        className={classnames('modal-connect modal-connect-first modal-connect--recruitment sp', { 'overlay': isConnectCompleteModalOpen })}
        onClick={(e) => e.stopPropagation()}
      >
        {isPerson && isScouted && (
          <h2 className="modal-connect-heading-updated first">
            スカウトを受けた求人です
          </h2>
        )}

        <h2 className="modal-connect-heading">
          エントリーするとできること
          <p className="modal-connect-heading-warning">
            {showMidCareerWarning && '※転職・中途向けの求人ですが、本当にエントリーしますか？'}
          </p>
        </h2>

        <div className="modal-connect-inner">
          <form className="modal-connect-form">
            <p className='text'>企業とメッセージでやり取りできます。気になることや伝えたいことがあれば、メッセージで企業に伝えてみましょう。</p>

            <div className="modal-connect-button dataLayer_company_id" id={`${companyId}`}>
              {!isLoggedIn ? (
                <>
                  <button className="button button-block">
                    エントリー
                  </button>
                  <p className="modal-connect-text modal-connect-text-first">
                    (ログインが必要です)
                  </p>
                </>
              ) : (
                <button
                  type="button"
                  className="button button-block button-submit gtm-entry-view-count"
                  onClick={handleSubmitConnect}
                  data-event-name='entry on screen'
                  data-event="click"
                  data-category="recruitmentcontent"
                  data-value="popup_entry"
                  disabled={isSubmitting}
                >
                  まずはエントリーする
                </button>
              )}
              <input id="recruitment_id" type="hidden" value={recruitmentId} />
            </div>
          </form>
        </div>
      </aside>
    </>
  );
};
